import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import SegfyLogo from "../Login/SegfyLogo";
import { loginUrlComCallback } from "../../helpers/navigation-helper";

const Default: React.FC = () => {
  let history = useHistory();

  useEffect(() => {
    const managementSoftwareUrl =
      process.env.REACT_APP_MANAGEMENT_SOFTWARE_SEGFY ?? "https://app.segfy.com";
    history.push(loginUrlComCallback(managementSoftwareUrl));
  }, [history]);

  return <SegfyLogo />;
};

export default Default;
